import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { MW_ANALYTICS } from 'constants/controllers'
import { defaultInterval } from 'constants/mw-analytics-intervals'
import Header from 'components/dealwatch/header'
import Main from './Main'
import Left from 'pages/mwanalytics/filters'

export default new Controller({
  name: MW_ANALYTICS,
  route: '(:aol/)markets/analytics',
  controller (Router, { url: pageId, pageView, query, params: { aol } }, render) {
    render(
      { Main, Header, Left },
      {
        aol,
        query: { i: query.i || defaultInterval, t: query.t || 'pma' },
        controller: MW_ANALYTICS
      },
      {
        aol,
        pageId: getUrl(MW_ANALYTICS),
        pageView,
        searchType: 'dealwatch',
        className: 'dealwatch'
      }
    )

    return pageId
  }
})
